import { getBrowserName, getBrowserVersion, getOS, getOSVersion } from '../../../utils';
import { firebaseFunctionsEndpoint, httpRequestWithToken } from '../../../utils/http';

interface PushClientLogsToElasticBody {
  tag: string;
  msg: string;
  level: 'info' | 'error' | 'warn';
  metaData?: Record<string, any>;
}

const pushClientLogsToElastic = async ({ tag, msg, level, metaData }: PushClientLogsToElasticBody) => {
  try {
    const url = `${firebaseFunctionsEndpoint}/pushClientLogsToElastic`;

    const os = {
      name: getOS().toLowerCase(),
      version: getOSVersion(),
    };

    const app = {
      platform: window.isElectron ? 'desktop' : 'web',
      environment: process.env.NODE_ENV,
      //TODO: We don't have version control in the webapp so we refer the commit hash
      version: process.env.HASH_COMMIT,
      build: process.env.HASH_COMMIT,
    };

    const browser = {
      name: getBrowserName(),
      version: getBrowserVersion(),
      userAgent: window.navigator.userAgent,
    };

    const storageEstimate = await navigator.storage.estimate();

    const device = {
      name: window.navigator.userAgent,
      language: window.navigator.language,
      region: window.navigator.language,
      orientation: window.innerWidth > window.innerHeight ? 'landscape' : 'portrait',
      ramFree: navigator.deviceMemory,
      storageFree: (storageEstimate?.quota || 0) - (storageEstimate?.usage || 0),
    };

    const timestamp: number = Date.now();

    await httpRequestWithToken({
      url,
      method: 'POST',
      payload: [{ tag, msg, level, ...metaData, os, app, browser, device, timestamp }],
    });
  } catch (error) {
    console.error('Error pushing client logs to Elastic:', error);
  }
};

export default pushClientLogsToElastic;
